import {
  DELETE_FLASHCARDS,
  FETCH_ALL_FLASHCARD_HEADERS,
  UPDATE_FLASHCARD_HEADER,
} from '../constants/actionTypes';

const flashcardHeaders = (flashcardHeaders = [], action) => {
  switch (action.type) {
    case FETCH_ALL_FLASHCARD_HEADERS:
      return action.payload;
    case UPDATE_FLASHCARD_HEADER: {
      const updated = action.payload;
      if (!updated?._id) {
        return flashcardHeaders;
      }
      const id = String(updated._id);
      return flashcardHeaders.map((card) =>
        String(card._id) === id
          ? { ...card, header: { ...card.header, ...updated.header } }
          : card,
      );
    }
    case DELETE_FLASHCARDS: {
      const id = String(action.payload);
      return flashcardHeaders.filter((card) => String(card._id) !== id);
    }
    default:
      return flashcardHeaders;
  }
};

export default flashcardHeaders;
